/* CENIT · Tarjeta compartida: compra rápida + carruseles deslizables + orden aleatorio.
   Eventos delegados: funciona con tarjetas que se agregan después (drawer, editor de temas). */
(function () {
  if (window.cenitCardReady) return;
  window.cenitCardReady = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function closeAll(except) {
    document.querySelectorAll('[data-cc-card].is-open').forEach(function (c) {
      if (c !== except) c.classList.remove('is-open');
    });
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof window.cenitUpdateCartHeader === 'function') window.cenitUpdateCartHeader(cart);
        document.dispatchEvent(new CustomEvent('cenit:cart-updated', { detail: { cart: cart } }));
        if (typeof window.cenitOpenAccountMenu === 'function') window.cenitOpenAccountMenu();
        return cart;
      });
  }

  /* Agrega varias piezas a la vez (sección "Arma tu set"). items: [{ id, quantity }] */
  window.cenitAddItems = function (items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw new Error(err && err.description || 'add'); });
      return refreshCart();
    });
  };

  function add(btn) {
    var id = btn.getAttribute('data-cc-variant');
    var card = btn.closest('[data-cc-card]');
    if (!id || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return refreshCart(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
          if (card) card.classList.remove('is-open');
        }, 900);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 1200);
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cc-toggle]');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('[data-cc-card]');
      closeAll(card);
      card.classList.toggle('is-open');
      return;
    }
    if (e.target.closest('[data-cc-close]')) {
      e.preventDefault();
      e.target.closest('[data-cc-card]').classList.remove('is-open');
      return;
    }
    var variant = e.target.closest('[data-cc-variant]');
    if (variant) {
      e.preventDefault();
      add(variant);
      return;
    }
    var nav = e.target.closest('[data-cc-prev],[data-cc-next]');
    if (nav) {
      var track = document.getElementById(nav.getAttribute('aria-controls'));
      if (!track) return;
      var dir = nav.hasAttribute('data-cc-next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }
    if (!e.target.closest('[data-cc-card]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  /* Orden aleatorio + quitar producto actual + límite visible */
  function shuffle(track) {
    if (track.dataset.ccShuffled) return;
    track.dataset.ccShuffled = '1';
    var exclude = track.getAttribute('data-cc-exclude');
    var items = Array.prototype.slice.call(track.children);
    if (exclude) {
      items = items.filter(function (el) {
        var card = el.matches('[data-product-id]') ? el : el.querySelector('[data-product-id]');
        if (card && card.getAttribute('data-product-id') === exclude) { el.remove(); return false; }
        return true;
      });
    }
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = items[i]; items[i] = items[j]; items[j] = t;
    }
    var limit = parseInt(track.getAttribute('data-cc-limit'), 10) || items.length;
    items.forEach(function (el, idx) {
      if (idx < limit) track.appendChild(el); else el.remove();
    });
  }

  /* Flechas: se desactivan en los extremos */
  function syncNav(track) {
    var id = track.id;
    if (!id) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    document.querySelectorAll('[aria-controls="' + id + '"]').forEach(function (b) {
      if (b.hasAttribute('data-cc-prev')) b.disabled = track.scrollLeft <= 2;
      if (b.hasAttribute('data-cc-next')) b.disabled = track.scrollLeft >= max;
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cc-shuffle]').forEach(shuffle);
    (scope || document).querySelectorAll('[data-cc-track]').forEach(function (track) {
      if (track.dataset.ccNav) { syncNav(track); return; }
      track.dataset.ccNav = '1';
      track.addEventListener('scroll', function () { syncNav(track); }, { passive: true });
      syncNav(track);
    });
  }

  window.cenitCardInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
